import React from "react";
import Page from "components/common/page/Page.component";
import MapRealtimeContainer from "containers/gis/realtime/MapRealtime.container";

const MapRealtimePage = ((props) => {
    return (
        <Page title='Mappa dati in tempo reale - GIS'>
            <MapRealtimeContainer  {...props} />
        </Page>
    );
})

export default MapRealtimePage;
